import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/apiBase";

const API = `${BACKEND_URL}/api`;

const FALLBACK = [
  { month: "Mai 2025",       monthly: 47.21,  cumulative: 47.21,  paused: false },
  { month: "Juni 2025",      monthly: 42.68,  cumulative: 110.71, paused: false },
  { month: "Juli 2025",      monthly: -0.88,  cumulative: 108.72, paused: false },
  { month: "August 2025",    monthly: 18.35,  cumulative: 147.06, paused: false },
  { month: "September 2025", monthly: 22.10,  cumulative: 201.55, paused: false },
  { month: "Oktober 2025",   monthly: 15.42,  cumulative: 248.04, paused: false },
  { month: "November 2025",  monthly: 9.88,   cumulative: 282.40, paused: false },
  { month: "Dezember 2025",  monthly: 31.07,  cumulative: 401.18, paused: false },
  { month: "Januar 2026",    monthly: -28.61, cumulative: 287.17, paused: false },
  { month: "Februar 2026",   monthly: 0,      cumulative: 287.17, paused: true },
  { month: "März 2026",      monthly: 0,      cumulative: 287.17, paused: true },
  { month: "April 2026",     monthly: 24.87,  cumulative: 383.41, paused: false },
];

export const useTrackRecord = () => {
  const [rows, setRows] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/track-record`)
      .then((res) => {
        if (!cancelled && Array.isArray(res.data) && res.data.length) {
          setRows(res.data.map((r) => ({ paused: false, ...r })));
        }
      })
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return { rows, loading };
};
